import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {TextPlugin} from 'gsap/TextPlugin'
// import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)
// gsap.registerPlugin(SplitText)
gsap.registerPlugin(TextPlugin) 

export default class Animations {
  static init() {
    console.debug('== Animations components ==')

    // General animations
    console.debug('  -> Animate general components')

    // const animateHero = document.querySelectorAll('#hero-explosion')
    const animateHero = document.querySelectorAll('.animate-out-away')
    if (animateHero.length != 0) {
      animateScrollHero(animateHero)
    }

    const animateRight = document.querySelectorAll('.animate-right')
    if (animateRight.length != 0) {
      animateHorizontal(animateRight, 20)
    }

    const animateLeft = document.querySelectorAll('.animate-left')
    if (animateLeft.length != 0) {
      animateHorizontal(animateLeft, -20)
    }

    const animateBottom = document.querySelectorAll('.animate-bottom')
    if (animateBottom.length != 0) {
      animateVertical(animateBottom, 20)
    }

    const animateTop = document.querySelectorAll('.animate-top')
    if (animateTop.length != 0) {
      animateVertical(animateTop, -20)
    }

    const animateFadeItems = document.querySelectorAll('.animate-fade')
    if (animateFadeItems.length != 0) {
      animateFade(animateFadeItems)
    }

    const animateBottomStagger = document.querySelectorAll('.animate-bottom-stagger')
    if (animateBottomStagger.length != 0) {
      animateInStaggerBottom(animateBottomStagger, 20, 0.15)
    }
  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

function animateScrollHero(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({ autoAlpha: 1, scale: 100, paused: true })

    tlItem.to(item, {
      autoAlpha: 0,
      scale: 0.7,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: '.section--hero',
      start: '5% top',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      scrub: true,
      toggleActions: 'play none none none',
    })
  })
}

function animateHorizontal(items, offset) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({ autoRemoveChildren: true, paused: true })

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      x: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 80%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

function animateVertical(items, offset, start = 'top 95%') {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      y: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: start,
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

function animateFade(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

const animateInStaggerBottom = (items) => {
  items.forEach((item) => {
    gsap.set(item, { autoAlpha: 1, y: 0 })

    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})
    let stItem = null

    // Select subitems within the main item
    const subitems = Array.from(
      item.querySelectorAll('.animate-stagger-item')
    )
    
    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity';

    if( subitems.length > 0 ){
      tlItem.from(subitems, {
        [property]: 0,
        duration: 0.75,
        y: 100,
        ease: 'Power2.easeOut',
        stagger: 0.2,
        onComplete: () => {
          stItem.kill()
          item.classList.remove('.animate-in-stagger-item')
        },
      })
  
      stItem = ScrollTrigger.create({
        trigger: item,
        start: 'top 70%',
        animation: tlItem,
        // markers: true,
        toggleActions: 'play none none none',
      })
    }
  })
}